import { ProgramModel } from '@cibo/core'
import { EditLand as EditLandComponent } from '@cibo/landmanager'
import { useCombinedBenchmarkRequirements } from '@cibo/programs'
import { useCallback } from 'react'

export const EditLand = () => {
  const isOpen = useCallback(
    ({ isClosedForEnrollment }: ProgramModel) => !isClosedForEnrollment,
    []
  )
  const profileRequirements = useCombinedBenchmarkRequirements('profile', isOpen)
  const prequalifyRequirements = useCombinedBenchmarkRequirements('prequalify', isOpen)
  const enrollmentRequirements = useCombinedBenchmarkRequirements('enrollment', isOpen)

  const traitRequirements = [
    ...(prequalifyRequirements.data || []),
    ...(profileRequirements.data || []),
    ...(enrollmentRequirements.data || []),
  ]

  return <EditLandComponent editLabel traitRequirements={traitRequirements} />
}
